const Margin = ({top = 0, right = 0, left = 0, bottom = 0, horizontal = 0, vertical = 0, children}) =>
  <div style={{
    marginTop: top ? top : vertical,
    marginRight: right ? right : horizontal,
    marginLeft: left ? left : horizontal,
    marginBottom: bottom ? bottom : vertical
  }}>{children}</div>;

export default Margin;



// WEBPACK FOOTER //
// ./components/Margin/Margin.js